"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraPositions = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _dCube = _interopRequireDefault(require("../../../../shared/assets/icons/2d-cube"));
var _dCube2 = _interopRequireDefault(require("../../../../shared/assets/icons/3d-cube"));
var _constants = require("../../../../utils/constants");
var _selectors = require("../../../../redux/selectors");
var _actions = require("../../../../redux/actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  colors
} = _paulCorePackage.constants;
const CameraPositions = exports.CameraPositions = /*#__PURE__*/(0, _react.memo)(() => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const activeCameraPerspective = (0, _reactRedux.useSelector)(_selectors.getActiveCameraPerspective);
  const is3D = activeCameraPerspective === _constants.CameraPerspective.ThreeD;
  const setPerspective = (0, _react.useCallback)(perspective => {
    dispatch((0, _actions.setActiveCameraPerspective)(perspective));
  }, [dispatch]);
  const getButtonSX = active => _objectSpread({
    padding: '8px',
    borderColor: colors['main-color-cl-16']
  }, active ? {
    backgroundColor: colors['main-color-cl-17']
  } : {});
  return /*#__PURE__*/_react.default.createElement(_material.ButtonGroup, {
    variant: "outlined",
    size: "large",
    sx: {
      pointerEvents: 'auto',
      backgroundColor: colors['main-color-cl-19']
    },
    disableElevation: true
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    sx: getButtonSX(!is3D),
    onClick: () => setPerspective(_constants.CameraPerspective.TwoD)
  }, /*#__PURE__*/_react.default.createElement(_dCube.default, null)), /*#__PURE__*/_react.default.createElement(_material.Button, {
    sx: getButtonSX(is3D),
    onClick: () => setPerspective(_constants.CameraPerspective.ThreeD)
  }, /*#__PURE__*/_react.default.createElement(_dCube2.default, null)));
});